import { useCallback, useEffect, useState } from "react";
import ListeValidationDemande from "./ListeValidationDemande";
import AccueilEspaceValideur from "./AccueilEspaceValideur";
import { DemandeAbsenceApi } from "../../api/DemandeAbsence";
import { useSessionStore } from "../../lib/Store/sessionStore.component";
import { DemandeAbsenceType } from "../../api/DemandeAbsence/types";
import { ContenuEspaceValideurProps } from "./EspaceValideur.types";
import { ValidationReponseApi } from "../../api/ValidationReponse/ValidationReponseApi";

export default function ContenuEspaceValideur({ openPlanning }: ContenuEspaceValideurProps) {
    const { getCurrentInfos } = useSessionStore();
    const { currentLogin } = getCurrentInfos();

    const [demandes, setDemandes] = useState<DemandeAbsenceType[]>([]);
    const [currentDisplay, setCurrentDisplay] = useState<'main' | 'absences'>('main')

    const openAbsences = useCallback(() => {
        setCurrentDisplay('absences')
    }, [])

    const handleReject = useCallback((demande: DemandeAbsenceType, commentaire?: string) => {
        ValidationReponseApi.updateValidationReponse({
            identifiantDemandeAbsence: demande.identifiant || 0,
            identifiantAgent: currentLogin?.identifiant || 0,
            reponse: 2,
            libelle: commentaire
        })
    }, [currentLogin?.identifiant])

    const handleValidate = useCallback((demande: DemandeAbsenceType, commentaire?: string) => {
        ValidationReponseApi.updateValidationReponse({
            identifiantDemandeAbsence: demande.identifiant || 0,
            identifiantAgent: currentLogin?.identifiant || 0,
            reponse: 3,
            libelle: commentaire
        })
    }, [currentLogin?.identifiant])

    useEffect(() => {
        DemandeAbsenceApi.getDemandesAValider(currentLogin?.identifiant || 0).then((data) => {
            setDemandes(data)
        })
    }, [currentLogin?.identifiant])

    switch (currentDisplay) {
        case 'main':
            return  (
                <AccueilEspaceValideur
                demandes={demandes}
                onMoreClicked={openAbsences}
                openPlanning={openPlanning}
                onReject={handleReject}
                onValidate={handleValidate}
                />
            );
        case 'absences':
            return <ListeValidationDemande demandes={demandes} onReject={handleReject} onValidate={handleValidate} />;
    }
}
